import React from 'react';
import styles from './Style.module.scss';
import cx from 'classnames';
import { Image } from "react-bootstrap";
import CloseTagIcon from '../images/close_tag.png';

class UserGroupTagView extends React.Component {
  constructor(props) {
    super(props);

    this._handleRemoveTag = this._handleRemoveTag.bind(this);
  }

  _handleRemoveTag(){
    if(this.props.onRemove){
      this.props.onRemove(this.props.option);
    }
  }

  render() {
    return (
      <div className={cx(styles.tag)}>
        {this.renderOption(this.props.option.option ? this.props.option.option : this.props.option)}
        <span className={styles.remove} onClick={this._handleRemoveTag}>
          <Image src={CloseTagIcon} className={styles.closeTag} />
        </span>
      </div>
    );
  }

  renderOption(tag){
    return this.renderDefault(tag);
  }

  renderDefault(tag){
    return (
      <span className={cx(styles.value)}>
        {tag.label}
      </span>
    );
  }

}

export default UserGroupTagView;